module.exports = __webpack_public_path__ + "static/media/台灣量化交易協會.9636a640.jpg";